import { Injectable } from '@angular/core';
import { CurrentUser } from '../models/user';
import { BehaviorSubject, Observable } from 'rxjs';

const AUTH_KEY = 'auth-data';
const USER_KEY = 'user-data';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private userSubject = new BehaviorSubject<CurrentUser | null>(this.getUserFromSession());
  user$ = this.userSubject.asObservable();

  private authSubject = new BehaviorSubject<{ token: string, userId: string } | null>(this.getAuthDataFromSession());
  auth$ = this.authSubject.asObservable();

  constructor() {}

  clean(): void {
    window.sessionStorage.clear();
    this.userSubject.next(null);
    this.authSubject.next(null);
  }

  public saveAuthData(authData: { token: string, userId: string }): void {
    window.sessionStorage.setItem(AUTH_KEY, JSON.stringify(authData));
    this.authSubject.next(authData);
  }

  public getAuthData(): { token: string, userId: string } | null {
    return this.authSubject.value;
  }

  private getAuthDataFromSession(): { token: string, userId: string } | null {
    const data = window.sessionStorage.getItem(AUTH_KEY);
    return data ? JSON.parse(data) : null;
  }

  public saveUser(user: CurrentUser): void {
    const userObj = CurrentUser.fromJson(user);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(user));
    this.userSubject.next(userObj);
  }

  public getUser(): CurrentUser | null {
    const user = this.userSubject.value;
    return user ? CurrentUser.fromJson(user) : null;
  }

  private getUserFromSession(): CurrentUser | null {
    const data = window.sessionStorage.getItem(USER_KEY);
    return data ? CurrentUser.fromJson(JSON.parse(data)) : null;
  }

  public isLoggedIn(): boolean {
    return !!this.getAuthData();
  }

  public logout(): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.removeItem(AUTH_KEY);
    this.userSubject.next(null);
    this.authSubject.next(null);
  }
}